export default __webpack_public_path__ + "static/media/undraw_update_uxn2.153d8c68.svg";